export const FLORIDA_STATE = 7;